import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";

const RING = "LUXURY RESALE ◆ SUPPLIER VAULT ◆ SEEDOSELLZ ◆ ";

export const Medallion = () => {
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rx = useSpring(useTransform(my, [-0.5, 0.5], [14, -14]), { stiffness: 120, damping: 18 });
  const ry = useSpring(useTransform(mx, [-0.5, 0.5], [-14, 14]), { stiffness: 120, damping: 18 });

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };
  const reset = () => { mx.set(0); my.set(0); };

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.85 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1], delay: 0.6 }}
      onMouseMove={onMove}
      onMouseLeave={reset}
      className="relative mx-auto w-[17rem] sm:w-[22rem] lg:w-[28rem] aspect-square [perspective:1200px]"
      data-testid="hero-medallion"
    >
      <svg viewBox="0 0 200 200" className="absolute inset-0 w-full h-full animate-spin-slow">
        <defs><path id="ring" d="M100,100 m-92,0 a92,92 0 1,1 184,0 a92,92 0 1,1 -184,0" /></defs>
        <text className="fill-[#D4AF37]" style={{ fontSize: 8.6, fontFamily: "Manrope" }}>
          <textPath href="#ring" textLength="570" lengthAdjust="spacing">{RING}</textPath>
        </text>
      </svg>
      <motion.div style={{ rotateX: rx, rotateY: ry, transformStyle: "preserve-3d" }} className="absolute inset-[11%] rounded-full">
        <div className="absolute inset-0 rounded-full bg-violet-600/40 blur-3xl" />
        <img src="/img/logo.webp" alt="SeedoSellz luxury resale logo"
          className="relative w-full h-full rounded-full object-cover shadow-[0_0_80px_rgba(168,85,247,0.45)]"
          style={{ transform: "translateZ(40px)" }} />
        <div className="absolute inset-0 rounded-full medallion-sheen pointer-events-none" style={{ transform: "translateZ(60px)" }} />
      </motion.div>
    </motion.div>
  );
};
